import '../../style/index.less';
import './index.less';
// style dependencies
import '../../input/style';



// WEBPACK FOOTER //
// ./components/select/style/index.tsx